import { SiteLocation } from "../models/site";
import axiosConfig from "./axiosConfig";

interface SiteLocationListResponse {
  sites: SiteLocation[];
}

const getSiteLocationList = async (
  authToken: string,
  testOrgId?: string | null
): Promise<SiteLocationListResponse> => {
  const params = new URLSearchParams();
  if (testOrgId) params.append("testOrgId", testOrgId);
  const { data } = await axiosConfig.get(
    `/site_location${params.size > 0 ? `?${params}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteLocationList;
